import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  max-width: 1000px;
  margin: 0 auto;
  flex: 1;
  min-height: 100vh;
`;

export const ContainerImagemNoticia = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: flex-end;

  width: 100%;
  height: 380px;
`;

export const ContainerConteudoNoticia = styled.div`
  display: flex;
  flex-direction: column;

  ${({ theme }) => {
    return css`
      background-color: ${theme.tokens.colors.white_contrast};
      padding: ${theme.spacing[5]}px 0;

      @media (min-width: 1200px) {
        padding: ${theme.spacing[5]}px;
        padding ${theme.spacing[7]}px 0;
      }
    `;
  }}
`;

export const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;

  @media (min-width: 1200px) {
    flex-direction: row;
    padding: 0px;
  }
`;

export const BodyWrapper = styled.div`
  span {
    height: auto !important;

    @media (max-width: 600px) {
      width: 100% !important;
    }
  }
`;

export const SideContainer = styled.div`
  width: 100%;

  @media (min-width: 500px) {
    min-width: 400px;
  }
`;
